import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/shared/components/ui/alert";
import { AlertCircle } from "lucide-react";
import t from "@/lang/lang";
import { Username } from "@/services/backend/auth/components/username";
import { Document } from "@bitory-gmbh/bsm";
import { DocumentStateBase } from "@/services/backend/documents/types/state";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * DocumentStateAlert tells the user that a document was written down and by
 * whom. Nothing is shown for a document that is still editable.
 */
export function DocumentStateAlert(props: {
  document: Document & DocumentStateBase;
}) {
  const { document } = props;
  if (!isImmutable(document)) {
    return null;
  }

  const documentKind = t(document.documentKind);
  const setAt = document.stateSetAt
    ? new Date(document.stateSetAt).toLocaleString()
    : "";
  const setBy = document.stateSetBy;

  return (
    <Alert>
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{documentKind} festgeschrieben</AlertTitle>
      <AlertDescription>
        <span>
          {`${documentKind} wurde am ${setAt} von `}
          <Username userId={setBy ?? ""} />
          {` festgeschrieben.`}
        </span>
      </AlertDescription>
    </Alert>
  );
}
